import { render, staticRenderFns } from "./ProfileMedicalHistoryDetail.vue?vue&type=template&id=013c5cf4&"
import script from "./ProfileMedicalHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileMedicalHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports